import { Stack, TextField, IconButton, Typography, InputAdornment } from '@mui/material';
import { FC, useRef, useCallback } from 'react';
import Iconify from '@/components/media/iconify';

type Props = {
  name: string;
  filters: Record<string, any>;
  onChange: (filters: Record<string, any>) => void;
  label?: string;
};

export const SearchText: FC<Props> = ({ name, filters, onChange, label }) => {
  const inputRef = useRef<HTMLInputElement>();

  const handleSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      onChange({
        ...filters,
        page: 0,
        [name]: value,
      });
    },
    [filters, name, onChange]
  );

  const clearSearch = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    onChange({
      ...filters,
      page: 0,
      [name]: '',
    });
  };

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        {label}
      </Typography>
      <TextField
        fullWidth
        inputRef={inputRef}
        value={filters[name] ?? ''}
        onChange={handleSearchChange}
        placeholder={label}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          ),
          endAdornment: !!filters[name]?.length && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={clearSearch}>
                <Iconify icon="octicon:x-12" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};
